import { CustomerAdjustmentPoint } from "pages/customer-management/CustomerAdjustmentPointModal";
import { SearchCustomerParams } from "pages/customer-management/CustomerManagement";
import axios from "./axios";

export type UpdateCustomer = {
    id: number;
} & CreateCustomer;

export type CreateCustomer = {
    name: string;
    phone: string;
}

export const getCustomers = async (page: number, pageSize: number, searchParams: SearchCustomerParams) => {
    const response = await axios.get(`/customer?page=${page}&pageSize=${pageSize}&search=${searchParams.search}&rank=${searchParams.rank}`);
    return response.data;
}

export const updateCustomer = async (customer: UpdateCustomer) => {
    const response = await axios.put(`/customer/${customer.id}`, customer);
    return response.data;
}

export const createCustomer = async (customer: CreateCustomer) => {
    const response = await axios.post(`/customer`, customer);
    return response.data;
}

export const adjustCustomerPoint = async (body: CustomerAdjustmentPoint, customerId: number) => {
    const response = await axios.post(`/customer/${customerId}/adjustment-point`, body);
    return response.data;
}

export const getCustomerOptions = async () => {
    const response = await axios.get("/customer/options");
    return response.data;
}